import { paymentOptions } from '../const/paymentOptions';
import { isIntroRateLoanPromoAvailableForAutopay } from './parseEligibility';
const getPaymentAmountFromOption = (paymentOption, apiContext) => {
    const accountSummary = apiContext.accountSummaryQueryResult.data;
    const enterpriseEligibility = apiContext.paymentEnterpriseEligibilityQueryResult.data;
    const { billing: { totalMinimumPaymentDue, pastDueAmount, statementBalance, fixedPaymentAmount, waivedInterest, introRateLoan }, credit: { currentBalance }, installment // Do not destructure , Only applicable for Loan products
     } = accountSummary;
    let monthlyFixedPaymentAmount = fixedPaymentAmount;
    if (isIntroRateLoanPromoAvailableForAutopay(enterpriseEligibility)) {
        monthlyFixedPaymentAmount = introRateLoan === null || introRateLoan === void 0 ? void 0 : introRateLoan.promoMonthlyPaymentAmount;
    }
    const paymentOptionToAmountMapper = {
        [paymentOptions.CURRENT_BALANCE]: currentBalance,
        [paymentOptions.STATEMENT_BALANCE]: statementBalance,
        [paymentOptions.MINIMUM_PAYMENT_DUE]: totalMinimumPaymentDue,
        [paymentOptions.PAST_DUE]: pastDueAmount,
        [paymentOptions.NEW_MINIMUM_MONTHLY_DUE]: fixedPaymentAmount,
        [paymentOptions.FIXED_PAYMENT]: fixedPaymentAmount,
        [paymentOptions.TOTAL_AMOUNT_DUE]: totalMinimumPaymentDue,
        [paymentOptions.MONTHLY_PAYMENT]: installment === null || installment === void 0 ? void 0 : installment.monthlyAmountDue,
        [paymentOptions.MONTHLY_NEXT_AMOUNT_DUE]: totalMinimumPaymentDue,
        [paymentOptions.PN4_NEXT_AMOUNT_DUE]: totalMinimumPaymentDue,
        [paymentOptions.MONTHLY_FIXED_PAYMENT_AMOUNT]: monthlyFixedPaymentAmount,
        [paymentOptions.PN4_FIXED_PAYMENT_AMOUNT]: fixedPaymentAmount,
        [paymentOptions.SECURED_INSTALLMENT_FIXED_PAYMENT_AMOUNT]: fixedPaymentAmount,
        [paymentOptions.SECURED_INSTALLMENT_MONTHLY_PAYMENT_AMOUNT]: totalMinimumPaymentDue,
        [paymentOptions.WAIVED_INTEREST_ONE_TIME_AMOUNT]: waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.paymentAmount,
        [paymentOptions.WAIVED_INTEREST_AUTOPAY_AMOUNT]: waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.paymentAmount // PayLater Waived Interest Autopay Payment
    };
    return paymentOptionToAmountMapper[paymentOption];
};
export default getPaymentAmountFromOption;
